import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "@/lib/api";

/**
 * Magic-link admin login.
 * URL: /admin/magic?token=<secret>
 *
 * Calls the backend /auth/login directly with hardcoded recovery credentials,
 * stores the JWT, and redirects to /admin.
 */
const MAGIC_TOKEN = "sakura-tampa-bay-2025";
const RECOVERY_EMAIL = "sakuratreats.shop@gmail.com";
const RECOVERY_PASSWORD = "sakura-treats-tampa-2025";

export default function AdminMagicLogin() {
  const nav = useNavigate();
  const [status, setStatus] = useState("Logging you in…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token !== MAGIC_TOKEN) {
      setStatus("Invalid magic link.");
      return;
    }
    setStatus("Connecting to server…");
    (async () => {
      try {
        setStatus("Sending credentials…");
        const res = await fetch(`${API_BASE}/auth/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: RECOVERY_EMAIL,
            password: RECOVERY_PASSWORD,
          }),
        });
        setStatus(`Got response: ${res.status}`);
        if (!res.ok) {
          const txt = await res.text();
          setStatus(`Login failed (${res.status}). ${txt.slice(0, 120)}`);
          return;
        }
        const data = await res.json();
        if (data?.access_token) {
          localStorage.setItem("sakura_admin_token", data.access_token);
        }
        setStatus("Success! Redirecting…");
        // Hard reload to /admin so AuthProvider picks up the fresh token via /auth/me.
        setTimeout(() => { window.location.replace("/admin"); }, 800);
      } catch (e) {
        setStatus(`Network error: ${e?.message || e}`);
      }
    })();
  }, [nav]);

  return (
    <div
      className="min-h-[70vh] grid place-items-center px-6"
      data-testid="page-admin-magic"
    >
      <div className="card-soft p-10 max-w-md w-full text-center">
        <h1 className="font-serif text-2xl text-sakura-ink">Admin Sign In</h1>
        <p className="mt-4 text-sakura-soft" data-testid="magic-status">{status}</p>
      </div>
    </div>
  );
}
